import { render, staticRenderFns } from "./PageLayout.vue.js?vue&type=template&id=20d6a4f3&scoped=true!=!../../../../node_modules/.pnpm/vue-loader@15.11.1_7oqlvuz5ddsjz7xbds5tjgd5iy/node_modules/vue-loader/lib/index.js??vue-loader-options!./PageLayout.vue?vue&type=template&id=20d6a4f3&scoped=true"
import script from "./PageLayout.vue.js?vue&type=script&lang=js!=!../../../../node_modules/.pnpm/vue-loader@15.11.1_7oqlvuz5ddsjz7xbds5tjgd5iy/node_modules/vue-loader/lib/index.js??vue-loader-options!./PageLayout.vue?vue&type=script&lang=js"
export * from "./PageLayout.vue.js?vue&type=script&lang=js!=!../../../../node_modules/.pnpm/vue-loader@15.11.1_7oqlvuz5ddsjz7xbds5tjgd5iy/node_modules/vue-loader/lib/index.js??vue-loader-options!./PageLayout.vue?vue&type=script&lang=js"
import style0 from "./PageLayout.vue.scss?vue&type=style&index=0&id=20d6a4f3&lang=scss&scoped=true!=!../../../../node_modules/.pnpm/vue-loader@15.11.1_7oqlvuz5ddsjz7xbds5tjgd5iy/node_modules/vue-loader/lib/index.js??vue-loader-options!./PageLayout.vue?vue&type=style&index=0&id=20d6a4f3&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_7oqlvuz5ddsjz7xbds5tjgd5iy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20d6a4f3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/web-hok_Mssh/node_modules/.pnpm/vue-hot-reload-api@2.3.4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('20d6a4f3')) {
      api.createRecord('20d6a4f3', component.options)
    } else {
      api.reload('20d6a4f3', component.options)
    }
    module.hot.accept("./PageLayout.vue.js?vue&type=template&id=20d6a4f3&scoped=true!=!../../../../node_modules/.pnpm/vue-loader@15.11.1_7oqlvuz5ddsjz7xbds5tjgd5iy/node_modules/vue-loader/lib/index.js??vue-loader-options!./PageLayout.vue?vue&type=template&id=20d6a4f3&scoped=true", function () {
      api.rerender('20d6a4f3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/global/PageLayout/PageLayout.vue"
export default component.exports